import {LitElement, css, html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {repeat} from 'lit/directives/repeat.js';
import {animate, fadeIn} from '@lit-labs/motion';
import {ContextConsumer} from '@lit/context';
import {artistContext } from '../context/artist-context.js';

@customElement('artist-active-filters')
export class ArtistActiveFilters extends LitElement {

  @state()
  private filters?: any = []

  @state()
  private term?: string = ''

  private tranformFilters(data:any) {
    let filters:any = []
    const filterCollections = data.filterCollections
    filterCollections?.map((filterCollection:any) => {
      filterCollection.filterGroups?.map((filterGroup:any) => {
        filterGroup.filterSets?.map((filterSet:any) => {
          filters = filters.concat(filterSet.filter)
        })
      })
    })
    return filters
  }
  private _onTermReset() {
    const options = {
      detail: '',
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent('artistSearchChange', options));
  }
  private _onChange(filter: any) {
    const options = {
      detail: filter.apiLink,
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent('artistFilterChange', options));
  }

  connectedCallback() {
    super.connectedCallback()
    new ContextConsumer(this, {
      context: artistContext,
      subscribe: true,
      callback: ({data}) => {
        if (data) {
          this.filters = this.tranformFilters(data)
          this.term = data.searchRequest?.term
          this.requestUpdate();
        }
      },
    });
  }

  render() {
    return html`
        ${this.term
                ? html`
                <div class="filter">
                    <button class="tag" @click="${() => this._onTermReset()}">
                        Search: ${this.term}
                    </button>
                </div>
              `
                : null}

        ${repeat(this.filters, (filter:any) => filter.identifier, (filter, i) => html`

            ${filter.selected
              ? html`
                <div class="filter" ${animate({
                            keyframeOptions: {
                                duration: 500,
                                delay: (i * 500) / this.filters.length,
                                fill: 'both',
                            },
                            in: fadeIn
                        })}>
                    <label class="tag">
                        <input .type="${filter.type}"
                               .checked="${filter.selected}"
                               .disabled="${!filter.enabled}"
                               @change="${() => this._onChange(filter)}">
                        <span>${filter.label}</span>
                    </label>
                </div>
              `
              : null}            
            
        `)}
        
    `}

  static styles = css`
      :host {
          display: block;
          margin: 1rem;
          font-family: inherit;
      }
      
      .filter {
          display: inline-block;
          margin-right:0.5rem;
          margin-bottom: 0.5rem;
      }
      
      .tag {
          line-height: 1;
          display: inline-flex;
          position: relative;
          cursor: pointer;
          padding: 0.5rem 1rem;
          padding-right: 3rem;
          background: #ffcc00;
          color: black;
          border: none;
          border-radius: var(--base-border-radius-full, 9999px);
          font-weight: bold;
         
      }
      .tag [type=checkbox] {
          position: absolute;
          right: 0;
          opacity: 0;
          pointer-events: none;
          padding: 0;
      }
      .tag [type=checkbox]+span {
          font-size: 1em;
          text-transform: uppercase;
      }
      .tag [type=checkbox]+span:before {
          content: "✕";
          font-weight: bold;
          font-size: 1rem;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 1rem;
          width: 1rem;
          height: 1rem;
          z-index: 0;
          box-shadow: none;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
      }
      
      button.tag {
          font-size: 1em;
          text-transform: uppercase;
      }
      button.tag:before {
          content: "✕";
          font-weight: bold;
          font-size: 1rem;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 1rem;
          width: 1rem;
          height: 1rem;
          z-index: 0;
          box-shadow: none;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
      }
      
      
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'artist-active-filters': ArtistActiveFilters
  }
}
